import classNames from 'classnames';
import styles from './Button.module.scss';

export interface ButtonProps {
	children: React.ReactNode;
	style?: 'theme' | 'theme-reverse' | 'primary' | 'secondary' | 'tertiary';
	size?: 'small' | 'medium';
	title?: string;
	className?: string;
	type?: 'button' | 'submit' | 'reset';
	disabled?: boolean;
	onClick?: () => void;
}

export const UI_Button = ({ children, style, size, title, className, type, disabled, onClick }: ButtonProps) => (
	<button
		type={type || 'button'}
		title={title}
		className={classNames(styles.Button, styles[`Button___${style}`], styles[`Button___${size}`], className)}
		disabled={disabled}
		aria-disabled={disabled}
		onClick={onClick}
	>
		<span>{children}</span>
	</button>
);
